import { create, METHOD } from '../utils'

export default {

    /** 搜索 */
    search: (props: {
        word: string,
    }) => create({
        url: "/egg/tyc/search",
        method: METHOD.GET
    })(props),

}